import React, { ReactNode } from "react";
import styles from "./GeneralModal.module.scss";
import { isMobile } from "react-device-detect";
import { createPortal } from "react-dom";
import { useGlobalContext } from "../../scanview/ScanViewerContext";

type GeneralModalProps = {
  show: boolean;
  children: ReactNode;
  ariaLabel?: string;
};

const GeneralModal = ({
  show,
  children,
  ariaLabel = "modal",
}: GeneralModalProps) => {
  const { scannerMainContainerRef, fullScreen, modalRef } = useGlobalContext();

  if (!show) {
    return <></>;
  }

  return createPortal(
    <div
      ref={modalRef}
      role="dialog"
      aria-modal={true}
      aria-label={ariaLabel}
      className={`${styles.generalModal} ${
        !fullScreen && !isMobile ? styles.noFullScreen : ""
      } ${isMobile ? styles.mobileView : ""}`}
    >
      {children}
    </div>,
    scannerMainContainerRef.current || document.body
  );
};

export default GeneralModal;
